module.exports = __webpack_public_path__ + "static/media/lv_call_true.b0f4c229.mp3";